import { render, staticRenderFns } from "./ProductGalleries.vue?vue&type=template&id=322d1ca7&scoped=true&"
import script from "./ProductGalleries.vue?vue&type=script&lang=js&"
export * from "./ProductGalleries.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleries.vue?vue&type=style&index=0&id=322d1ca7&scoped=true&lang=css&"
import style1 from "./ProductGalleries.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d1ca7",
  null
  
)

export default component.exports